import { render } from "./ExpenseCategorySelect.vue?vue&type=template&id=71f8a1ae"
import script from "./ExpenseCategorySelect.vue?vue&type=script&lang=js"
export * from "./ExpenseCategorySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__